import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeConfig, getConfig } from './services/configManager';

const startApp = async () => {
  await initializeConfig(); // Wait for config before rendering

  // Set CSS variables from runtime config (if available)
  if (getConfig().COLORS?.PrimaryBtn) {
    document.documentElement.style.setProperty('--primary-btn', getConfig().COLORS.PrimaryBtn);
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

startApp();

